module.exports = __webpack_public_path__ + "img/floral-7887374_1280_thumb.547acef9.jpg";